export const errorMessages = {
  requiredField: 'FORM_VALIDATION.FORM_ERROR_REQUIRED',
  email: 'FORM_VALIDATION.EMAIL_VALIDATION',
};
